import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "App-Talent-List" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_appTalent = _resolveComponent("appTalent")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, { gutter: 12 }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.talents, (t) => {
          return (_openBlock(), _createBlock(_component_el_col, {
            key: `tal-${t._id}`,
            span: 24,
            md: 12
          }, {
            default: _withCtx(() => [
              _createVNode(_component_appTalent, {
                otherTalents: _ctx.talents,
                opportunity: _ctx.opportunity,
                user: t
              }, null, 8, ["otherTalents", "opportunity", "user"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    })
  ]))
}